export default __webpack_public_path__ + "static/media/PM_LOGO_FINAL-03.ddac01f8.png";